import { render, staticRenderFns } from "./orgSummary.vue?vue&type=template&id=270601d2&scoped=true"
import script from "./orgSummary.vue?vue&type=script&lang=js"
export * from "./orgSummary.vue?vue&type=script&lang=js"
import style0 from "./orgSummary.vue?vue&type=style&index=0&id=270601d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270601d2",
  null
  
)

export default component.exports